import { queryOptions, useQuery } from '@tanstack/react-query'
import { getPlans } from '../services/getPlans.service'
import { plansKeys } from '../constants/plans.queryKeys'

export const plansQueryOptions = () =>
  queryOptions({
    queryKey: plansKeys.pricingTable(),
    queryFn: getPlans,
    staleTime: 5 * 60 * 1000,
  })

export function usePlans() {
  return useQuery(plansQueryOptions())
}
